import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '~/ui';
import s from './NotFound.module.scss';

const Content = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={s.container}>
      <div className={s.code}>404</div>
      <div className={s.title}>{t('not_found_title')}</div>
      <div className={s.description}>
        {t('not_found_description')}
      </div>
      <Button
        onClick={() => navigate('/')}
        text={t('not_found_go_home')}
        disabled={false}
      />
    </div>
  );
};

export default Content;
